import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const ErrorPage: React.FC = () => {
  const location = useLocation();
  const errorMessage = location.state?.message || 'An unknown error occurred';
  const navigate = useNavigate();

  const goHome = () => {
    navigate('/'); // Ana sayfaya yönlendirme
  };

  return (
    <div>
      <h1>Error</h1>
      <p>{errorMessage}</p>
      <button onClick={goHome}>Go to Home</button>
    </div>
  );
};

export default ErrorPage;


// import React from 'react';
// import { useNavigate } from 'react-router-dom';

// const ErrorPage: React.FC = () => {
//   const navigate = useNavigate();

//   const goHome = () => {
//     navigate('/'); // Ana sayfaya yönlendirme
//   };

//   return (
//     <div>
//       <h1>Error occurred!</h1>
//       <p>Something went wrong. Please try again or contact support.</p>
//       <button onClick={goHome}>Go to Home</button>
//     </div>
//   );
// };

// export default ErrorPage;
